import { Banner } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"

export const CSVExportSuggestion = () => {
	const { t } = useTranslation()
	const showCrispChatArticle = () => {
		if (window?.$crisp?.push) {
			window.$crisp.push([
				"do",
				"helpdesk:article:open",
				["en", "csv-export-v2m2rs"],
			])
		}
	}

	return (
		<div style={{ marginTop: "1rem", marginBottom: "1rem" }}>
			<Banner status="warning">
				<p>
					{t("other.importing_fails_it_might_be_because")}{" "}
					<a
						style={{
							textDecoration: "underline",
							color: "#333",
							cursor: "pointer",
						}}
						onClick={showCrispChatArticle}
					>
						{t("other.show_me_how")}
					</a>
				</p>
			</Banner>
		</div>
	)
}
